import { environment } from 'src/environments/environment';
import { NavigationEnd, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Component, ElementRef, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { MenuOption } from 'src/app/models/menuOption.models';
import { ErrorsService } from 'src/app/services/errors.service';
import { ModalComponent } from '../modal/modal.component';
import { DrawerService } from 'src/app/services/ui/drawer.service';
import {
  BehaviorSubject,
  Observable,
  Subscription,
  filter,
  fromEvent,
  map,
  merge,
  startWith,
} from 'rxjs';
import { AuthService } from 'src/app/auth.service';
import { MetadataService } from 'src/app/services/metadata/metadata.services';
import { CreationalPagesLayoutService } from '../../../services/ui/creational-pages-layout.service';
import { UserService } from 'src/app/services/users/users.service';
import { RoomsService } from 'src/app/services/rooms/rooms.service';
import { SearchService } from 'src/app/services/search/search.service';

@Component({
  selector: 'app-modern-drawer',
  templateUrl: './modern-drawer.component.html',
  styleUrls: ['./modern-drawer.component.scss'],
})

export class ModernDrawerComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(ModalComponent) modal!: ModalComponent;
  @ViewChild('drawerButton') drawerButton!: ElementRef<HTMLButtonElement>;
  @ViewChild('openDrawerIcon') openDrawerIcon!: ElementRef<SVGPathElement>;
  @ViewChild('closeDrawerIcon') closeDrawerIcon!: ElementRef<SVGPathElement>;

  @ViewChild('navbarWrapper') navbarWrapper!: ElementRef<HTMLDivElement>;

  appUrl: string;
  options: MenuOption[] = [
    {
      link: '/dashboard/institution/classes/list',
      slug: 'classes',
      icon: '/assets/images/icons/icon_class.svg',
      title: 'sidebar.classes',
    },
    {
      link: '/dashboard/institution/list',
      slug: 'colegios',
      icon: '/assets/images/icons/icon_home.svg',
      title: 'sidebar.institutions',
      institutionMode: true,
    },
    {
      link: '/dashboard/institution/search-results',
      slug: 'search',
      icon: '/assets/images/icons/icon_search.svg',
      title: 'sidebar.search',
      searchMode: true,
    },
    {
      link: '/dashboard/training',
      slug: 'training',
      icon: '/assets/images/icons/training-icon.svg',
      title: 'sidebar.formaciones',
      trainingMode: true,
    },
    // {
    //   link: '/dashboard/pages/contenidos',
    //   slug: 'pages',
    //   icon: '/assets/images/icons/icon_content.svg',
    //   title: 'Contenido',
    // },
    // {
    //   link: '/dashboard/grupos',
    //   slug: 'teams',
    //   icon: '/assets/images/icons/icon_team.svg',
    //   title: 'Grupos',
    // },
    // {
    //   link: '/dashboard/usuarios',
    //   slug: 'users',
    //   icon: '/assets/images/icons/icon_user.svg',
    //   title: 'Usuarios',
    // },
    // {
    //   link: '/dashboard/cupones',
    //   slug: 'coupons',
    //   icon: '/assets/images/icons/icon_coupon.svg',
    //   title: 'Cupones',
    // },
    // {
    //   link: '/dashboard/reportes',
    //   slug: 'reportes',
    //   icon: '/assets/images/icons/icon_career_university.svg',
    //   title: 'Reportes',
    // },
    // {
    //   link: '/dashboard/insight',
    //   slug: 'insight',
    //   icon: '/assets/images/icons/icon_insight.svg',
    //   title: 'Insight',
    // },
    // {
    //   link: '/dashboard/instituciones',
    //   slug: 'institutions',
    //   icon: '/assets/images/icons/icon_build.svg',
    //   title: 'Instituciones',
    // },
    // {
    //   link: '/dashboard/configuracion',
    //   slug: 'configuracion',
    //   icon: '/assets/images/icons/icon_settings.svg',
    //   title: 'Configuraciones',
    // },
  ];
  showDrawer = false;
  private debouncedDrawerSubscriptionRef!: Subscription;
  private changeDrawerBtnColorSubscriptionRef!: Subscription;
  private drawerOpenSubscription!: Subscription;
  public logoLink!: string;
  public brandLogoToShow$!: Observable<string>;
  public headerBgConfig = new BehaviorSubject<{
    mainColor: string;
    secondaryColor: string;
    fontColor: string;
  }>({
    mainColor: '#08142b',
    secondaryColor: '#ededed',
    fontColor: '#000',
  });


  constructor(
    private cookieService: CookieService,
    private errorsService: ErrorsService,
    private authService: AuthService,
    public metaDataService: MetadataService,
    private router: Router,
    private drawerService: DrawerService,
    private creationalPagesLayoutService: CreationalPagesLayoutService,
    private userService: UserService,
    private roomService: RoomsService,
    private searchService: SearchService,
  ) {
    this.appUrl = environment.appUrl;
  }

  ngOnInit(): void {
    this.brandLogoToShow$ = this.metaDataService.brandLogo;
    this.getUserData();
    this.drawerService.setDrawerOpen = this.showDrawer;
  }

  private buildPrincipalBrandLogoStream(user: any): Observable<string> {
    return this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map(() => this.router.url),
      startWith(this.router.url),
      map((url) => {
        const match = url.match(/\/dashboard\/institution\/classes\/list\/(\d+)/);
        if (!match) return '';
        const orgId = Number(match[1]);
        return user.users_organizations?.find(
          (o: any) => o.organization === orgId,
        )?.logo ?? '';
      }),
    );
  }

  ngAfterViewInit(): void {
    this.drawerOpenSubscription = this.drawerService.isDrawerOpen.subscribe(
      (value) => {
        if (value) {
          this.drawerService.applyInAnimation(this.navbarWrapper, 0, {
            width: this.drawerService.drawerWidth + 'px',
            transitionProperty: 'width',
            transitionDelay: '300ms',
            transitionDuration: '60ms',
          });
        } else {
          this.drawerService.applyOutAnimation(this.navbarWrapper, 0, {
            width: '0px',
            transitionProperty: 'width',
            transitionDelay: '20ms',
            transitionDuration: '70ms',
          });
        }
      }
    );

    this.debouncedDrawerSubscriptionRef = this.drawerService.isDrawerOpen
      .pipe(startWith(true))
      .subscribe((isDrawerOpen) => {
        if (isDrawerOpen) {
          this.drawerService.applyInAnimation(this.drawerButton, 0, {
            transitionDelay: '300ms',
            transitionDuration: '100ms',
          });
        } else {
          this.drawerService.applyOutAnimation(this.drawerButton, 0, {
            transitionDelay: '30ms',
            transitionDuration: '100ms',
          });
        }
      });

    this.changeDrawerBtnColorSubscriptionRef =
      this.changeDrawerBtnColor().subscribe((value) => {
        if (value === 'mouseover') {
          if (this.openDrawerIcon) {
            this.openDrawerIcon.nativeElement.setAttribute('fill', '#fff');
          }

          if (this.closeDrawerIcon) {
            this.closeDrawerIcon.nativeElement.setAttribute('fill', '#fff');
          }
        }

        if (value === 'mouseout') {
          if (this.openDrawerIcon) {
            this.openDrawerIcon.nativeElement.setAttribute('fill', '#000');
          }

          if (this.closeDrawerIcon) {
            this.closeDrawerIcon.nativeElement.setAttribute('fill', '#000');
          }
        }
      });
  }

  ngOnDestroy() {
    if (this.debouncedDrawerSubscriptionRef) {
      this.debouncedDrawerSubscriptionRef.unsubscribe();
    }
    if (this.drawerOpenSubscription) {
      this.drawerOpenSubscription.unsubscribe();
    }
    if (this.changeDrawerBtnColorSubscriptionRef) {
      this.changeDrawerBtnColorSubscriptionRef.unsubscribe();
    }
  }

  isImage(url: string) {
    return /jpg|jpeg|png|webp|avif|gif|svg/.test(url);
  }

  logoutHandler() {
    const refreshToken = {
      refresh: this.cookieService.get('gr_refresh'),
    };

    const cleanup = () => {
      localStorage.removeItem('brandlogo');
      this.cookieService.delete('gr_access', '/');
      this.cookieService.delete('gr_refresh', '/');

      // Limpiar cachés de servicios
      this.userService.clearUserProfileCache();
      this.userService.clearCurrentUser();
      this.roomService.clearInstitutionCache();
      this.searchService.clearSearch();

      this.creationalPagesLayoutService.institutionId.next(null);
      this.metaDataService.brandLogo.next('');
      this.router.navigate(['/signin'], { replaceUrl: true }).then(() => {
        this.authService.resetLogoutFlag();
      });
    };

    this.authService.logout(refreshToken).subscribe({
      next: () => cleanup(),
      error: () => cleanup()
    });
  }

  public toggleShow(): void {
    this.showDrawer = !this.showDrawer;
    this.drawerService.setDrawerOpen = this.showDrawer;
  }

  private changeDrawerBtnColor(): Observable<string> {
    if (!this.drawerButton?.nativeElement) {
      return new Observable();
    }
    return merge(
      fromEvent(this.drawerButton.nativeElement, 'mouseover').pipe(
        map(() => 'mouseover')
      ),
      fromEvent(this.drawerButton.nativeElement, 'mouseout').pipe(
        map(() => 'mouseout')
      )
    );
  }

  private getUserData() {
    const token = this.cookieService.get('gr_access');
    const decode_token = this.authService.getDecodedAccessToken(token);
    this.userService.getUserProfileData(decode_token.user_id).subscribe({
      next: (value) => {
        if (value.user_type === 'Principal') {
          this.brandLogoToShow$ = this.buildPrincipalBrandLogoStream(value);
          this.options = this.options.filter(
            (option) => option.institutionMode || option.searchMode || option.trainingMode
          );
          this.logoLink = '/dashboard/institution/list';
        } else if (value.user_type === 'Teacher' || value.user_type === 'School' || value.user_type === 'Back_Office_Admin' || value.user_type ===  'Principal') {
          this.options = this.options.filter(
            (option) => !option.institutionMode || option.searchMode || option.trainingMode
          );
          this.logoLink = '/dashboard/institution';
        } else {
          this.options = this.options.filter((option) => !option.trainingMode);
        }

        // Obtener colores de la organización
        if (value.users_organizations && value.users_organizations.length) {
          const orgId = value.users_organizations[0].organization;
          this.getOrganization(orgId);
        }
      },
      error: (error) => this.errorsService.handleErrors(error),
    });
  }

  private getOrganization(institutionId: string) {
    this.roomService.getInstitutionHeader(institutionId).subscribe({
      next: (data) => {
        this.headerBgConfig.next({
          mainColor: data.primary_color,
          secondaryColor: data.secondary_color,
          fontColor: data.font_color,
        });
      },
    });
  }
}
